import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { TtdAudiencesService } from 'src/app/services/audiences/ttd-audiences.service';
import { Partner } from 'src/app/models/services/audiences/ttd/partner';
import { Advertiser } from 'src/app/models/services/audiences/ttd/advertiser';

@Component({
  selector: 'app-ttd-attributes',
  templateUrl: './ttd-attributes.component.html',
  styleUrls: ['./ttd-attributes.component.sass']
})
export class TtdAttributesComponent implements OnInit {

    @ViewChild('matAutocompletePartners') inputAutocompletePartners: ElementRef<HTMLInputElement>;
    @ViewChild('matAutocompleteAdvertisers') inputAutocompleteAdvertisers: ElementRef<HTMLInputElement>;
  
    @Input() 
    form: FormGroup;
  
    @Input() 
    updateValueAndValidity: () => void;

    partners: Partner[] = [];
    filteredPartners: Partner[] = [];
    partnerAdvertisers: Advertiser[] = [];
    filteredPartnerAdvertisers: Advertiser[] = [];
  
    constructor(
      private ttdAudiencesServices: TtdAudiencesService,
      private spinnerService: NgxSpinnerService
    ) {
    }
  
    ngOnInit(): void {
      this.spinnerService.show("dialogSpinner");
      this.form.controls.firstPartyData.setValue('0');
      this.ttdAudiencesServices.getPartners().subscribe(
        resp => {
          this.partners = resp;
          this.onFirstPartyDataSelectedChange();
          
          this.spinnerService.hide("dialogSpinner");
          this.onPartnerChange(null);
        }
      )
    }
     
    onFirstPartyDataSelectedChange = (): void => {
      if (!!(+this.form.controls.firstPartyData.value)) {
        this.form.controls.advertiserId.setValidators([Validators.required]);
        this.form.controls.percentOfMediaCostRate.setValidators([]);
        this.form.controls.cpmRateAmount.setValidators([]);
      }
      else {
        this.form.controls.advertiserId.setValidators([]);
        this.form.controls.percentOfMediaCostRate.setValidators([Validators.required, Validators.min(0.1), Validators.max(1)]);
        this.form.controls.cpmRateAmount.setValidators([Validators.required, Validators.min(0.1)]);
      }
      this.form.controls.advertiserId.updateValueAndValidity();
      this.form.controls.percentOfMediaCostRate.updateValueAndValidity();
      this.form.controls.cpmRateAmount.updateValueAndValidity();
      this.updateValueAndValidity();      
    }

    resetPartnersFilter = (): void => {
      this.inputAutocompletePartners.nativeElement.value = '';
      this.resetPartnerControls(this.partners);
    }
      
    filterPartners = (): void => {
      const filterValue = this.inputAutocompletePartners.nativeElement.value.toLowerCase();
      this.resetPartnerControls(this.partners.filter(p => `${p.name} (${p.id})`.toLowerCase().includes(filterValue)));
    }
  
    onPartnerChange = ($event: MatAutocompleteSelectedEvent): void => {    
      this.inputAutocompletePartners.nativeElement.blur();
      var partner = this.partners.find(x => x.id == this.form.controls.partnerId.value);
      if(!!partner) {
        this.inputAutocompletePartners.nativeElement.value = this.getPartnerDescription(this.form.controls.partnerId.value);
        this.partnerAdvertisers = this.partners.find(x => x.id == this.form.controls.partnerId.value)?.advertisers;
        this.updateValueAndValidity();  
      }
      else
        this.resetPartnersFilter();      
    }
  
    onPartnerDescriptionChange = (): void => {
      this.updateValueAndValidity();
    }

    getPartnerDescription = (partnerId: string): string => {
      var partner = this.partners.find(x => x.id == partnerId);
      return !!partner ? `${partner.name} (${partner.id})` : '';
    }

    resetAdvertisersFilter = (): void => {
      this.inputAutocompleteAdvertisers.nativeElement.value = '';
      this.resetAdvertiserControls(this.partnerAdvertisers);
    }
      
    filterAdvertisers = (): void => {
      const filterValue = this.inputAutocompleteAdvertisers.nativeElement.value.toLowerCase();
      this.filteredPartnerAdvertisers = this.partnerAdvertisers.filter(o => o.name.toLowerCase().includes(filterValue));
      this.updateValueAndValidity();
    }
  
    onAdvertiserChange = ($event: MatAutocompleteSelectedEvent): void => {    
        this.inputAutocompleteAdvertisers.nativeElement.blur();
        var advertiser = this.partnerAdvertisers.find(x => x.id == this.form.controls.advertiserId.value);
        if(!!advertiser) {
          this.inputAutocompleteAdvertisers.nativeElement.value = this.getAdvertiserDescription(this.form.controls.advertiserId.value);
          this.updateValueAndValidity();  
        }
        else
          this.resetAdvertisersFilter();      
  
    }
  
    onAdvertiserDescriptionChange = (): void => {
      this.updateValueAndValidity();
    }

    getAdvertiserDescription = (advertiserId: string): string => {
      var advertiser = this.partnerAdvertisers.find(x => x.id == advertiserId);
      return !!advertiser ? `${advertiser?.name} (${advertiser?.id})` : '';
    }    

    resetPartnerControls = (filteredPartners: Partner[]): void => {
      this.filteredPartners = filteredPartners;
      if (filteredPartners == this.partners)
        this.form.controls.partnerId.setValue(null);
      if (!!this.inputAutocompleteAdvertisers)
        this.inputAutocompleteAdvertisers.nativeElement.value = '';

      this.partnerAdvertisers = [];
      this.resetAdvertiserControls([]);
    }

    resetAdvertiserControls = (filteredAdvertisers: Advertiser[]): void => {
      this.filteredPartnerAdvertisers = filteredAdvertisers;
      if (filteredAdvertisers == this.partnerAdvertisers || filteredAdvertisers.length == 0)
        this.form.controls.advertiserId.setValue(null);         
      this.updateValueAndValidity(); 
    }    

    onComponentBlur = (): void => {
      this.updateValueAndValidity();
    }
}
  